module.exports = __webpack_public_path__ + "static/img/gptModel53.fa584fbd.png";